/**
 * @fileoverview The i18next namespace the feedback-ui bundles register under.
 * @package @puffin-core/feedback-ui
 *
 * A ZERO-IMPORT leaf module, deliberately: `useFeedbackUiTranslate()` is imported by every component in
 * this package, and routing the constant through `strings/index.js` would drag `en.js` and `es.js` into
 * every one of those import chains for one short string.
 *
 * SAVE-FEEDBACK-CANON-001 P3 (2026-10-13) — born on the namespace mechanism when the three feedback
 * primitives left page-shell's `shell` namespace for a leaf package.
 *
 * @module @puffin-core/feedback-ui/strings/namespace
 */

/** The canonical namespace under which feedback-ui strings live in i18next. */
export const FEEDBACK_UI_NAMESPACE = 'feedbackUi';

/**
 * The namespace's ordinal in the APP registry — STAMPED BY THE COORDINATOR AT THE JOIN, never chosen
 * by a lane (#36–#38 were issued the same way). `null` until then; nothing reads a number (the registry
 * takes the NAME; `registries.test.js` pins the order and `registryLabel.contracts.test.js` the count),
 * so the placeholder is tolerated everywhere the name is used.
 */
export const FEEDBACK_UI_NAMESPACE_NUMBER = 41;
